import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "パターン1" },
  { value: 2, text: "パターン2" },
  { value: 3, text: "パターン3" },
  { value: 4, text: "パターン4" },
]);
